export const getKeyValuePair = (
  contentOrConfigData: any,
  tableName: any,
  key: any
) => {
  let _value: any = null;
  if (contentOrConfigData && contentOrConfigData.length > 0 && key) {
    contentOrConfigData?.forEach((item: any) => {
      if (item?.config && item?.config?.length > 0) {
        if (extractDateFromSniConfig(item, tableName, key))
          _value = extractDateFromSniConfig(item, tableName, key);
      } else if (item?.content && item?.content?.length > 0) {
        if (extractDateFromContentStack(item, tableName, key))
          _value = extractDateFromContentStack(item, tableName, key);
      }
    });
  }
  return _value;
};
const extractDateFromContentStack = (
  itemData: any,
  tableName: string,
  key: string
) => {
  let tempValue = null;
  itemData?.content?.forEach((_elem: any) => {
    if (
      _elem?.contentTypeName === tableName && //!TODO : get proper field name
      _elem?.output &&
      _elem?.output?.length > 0
    ) {
     
      _elem?.output?.forEach((_outputItem: any) => {
        tempValue = _outputItem.content;
       if (_outputItem.name === key)tempValue = _outputItem.content;
      })
    }
  });
  return tempValue;
};
const extractDateFromSniConfig = (
  itemData: any,
  tableName: string,
  key: string
) => {
  let tempValue = null;
  itemData?.config?.forEach((_elem: any) => {
    if (
      _elem?.configTableName === tableName &&
      _elem?.output &&
      _elem?.output?.length > 0
    ) {
      _elem?.output?.forEach((_outputItem: any) => {
        if (_outputItem.KEY === key) tempValue = _outputItem.VALUE;
      });
    }
  });
  return tempValue;
};
